import React from "react";
import { useParams } from "react-router-dom";
import useUser, { useGetUserId } from "./useUser";
import { useTranslation } from "react-i18next";
import { SPECIES_CLINIC_DTO } from "../enums/ApiPaths";
import { useFetch } from "./Fetching";

export default function useGetTranslatedSpecies() {
  const { id: userId } = useParams();
  const loggedInuserId = useGetUserId();
  const { t, i18n } = useTranslation();
  const { currentClinic, roles } = useUser();
  const isMaster = roles.master;
  const apiPath = isMaster ? "/species/" : SPECIES_CLINIC_DTO;
  const {
    data,
    isLoading: fetchLoading,
    error,
  } = useFetch(apiPath, currentClinic?.id, "species" + currentClinic?.id);
  const [translatedSpecies, setTranslatedSpecies] = React.useState([]);

  const allSpecies = isMaster ? data : data?.species || [];

  React.useEffect(() => {
    if (allSpecies) {
      const currentLang = i18n.language;
      const translation = allSpecies.map((species) => {
        if (species?.translations) {
          return {
            id: species.id,
            title: species?.translations[currentLang] || species.title,
            breed: species?.breed,
          };
        } else {
          return {
            id: species.id,
            title: species.title,
            breed: species?.breed,
          };
        }
      });
      setTranslatedSpecies(translation);
    }
  }, [allSpecies, i18n.language]);

  return { translatedSpecies };
}
